import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Home } from 'src/routes/new_home/mod';
import { SpaContext } from 'Public_old/src/app/Classes/spacontext';
import { SpaEventService } from 'Public_old/src/app/Services/spaEvents.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';
import { Root, createRoot } from 'react-dom/client';

const containerElementName = 'reactHomeComponent';

@Component({
	standalone: false,
	selector: 'home-component',
	template: `
		<semantic-view>
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class HomeWrapperComponent implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly router: Router,
		private readonly ngZone: NgZone,
		private readonly spaEventService: SpaEventService,
		private readonly spaContext: SpaContext,
	) {}

	ngOnChanges(_: SimpleChanges): void {
		// noop
	}

	ngAfterViewInit(): void {
		const rootUnit = this.spaContext.findUnit(this.spaContext.rootUnitId);
		if (!this.spaContext.unitConfig.LicenceHolder.HasMultipleLandingPages && !rootUnit.IsClientEntrance) {
			const onlyOffer = this.spaContext.unitTreeFlat.find((unit) => unit.IsListedToClients && unit.IsClientEntrance);
			if (onlyOffer) {
				this.spaEventService.onChangeUnit.emit({ unitId: onlyOffer.Id });

				return;
			}
		}

		this.render();
	}

	ngOnDestroy(): void {
		this.root?.unmount();
	}

	private signIn(): void {
		this.spaEventService.onSignInRequired.emit({
			leave: false,
			target: this.router.url,
			reason: null,
		});
	}

	private async render(): Promise<void> {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const forwardSignIn = (): void => {
			this.ngZone.run(() => {
				this.signIn();
			});
		};

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<Home __TEMP__onSignIn={forwardSignIn} />
				</CellulaProviderWrapper>,
			);
		});
	}
}
